import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  riderForm: {
     position: "relative",
  }
}));

export default useStyles;
